// extracted by mini-css-extract-plugin
module.exports = {"confirm":"Confirm_confirm__1FECo","inline-buttons":"Confirm_inline-buttons__1UnHA","message":"Confirm_message__sD76Z"};